import apiClient from "../../utils/apiClient";

const API_URL = "/admin/payment-settings";

export async function getActivePaymentSetting() {
  const response = await apiClient.get(`${API_URL}/active`);
  return response.data;
}

export async function createPaymentSetting(payload) {
  const response = await apiClient.post(`${API_URL}`, payload);
  return response.data;
}

export async function updatePaymentSetting(settingId, payload) {
  const response = await apiClient.put(`${API_URL}/${settingId}`, payload);
  return response.data;
}

